import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class PolygonEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITPOLYGON;
}